import { Component, ViewChild, AfterViewInit, ViewContainerRef, ComponentFactoryResolver, ComponentFactory, ComponentRef, TemplateRef, Type, OnDestroy, HostListener, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { PageSharedFns } from 'src/app/services/pageSharedFunctions';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import Swal from 'sweetalert2';
import { SharedInfo } from 'src/app/services/shared-info';
import { GroupAddEditComponent } from '../stock/group-add-edit/group-add-edit.component';
import { ProductAddEditComponent } from '../stock/product-add-edit/product-add-edit.component';
import { GroupDataService } from '../stock/group-add-edit/group.service';
import { UserService } from 'src/app/services/user-service';
import { HttpClient } from '@angular/common/http';
import { ProductDataService } from '../stock/product-add-edit/product.service';
import { SharedAnimations } from 'src/app/shared/animations/shared-animations';
import { StockMovementAddEditComponent } from '../stock/product-stock-add-edit/stock-mov-add-edit.component';
import { StockMovementDataService } from '../stock/product-stock-add-edit/stock-mov.service';
import { GenericDataService } from '../../../services/generic.service';
import { PersonAddEditComponent } from '../catalog/person/person-add-edit/person-add-edit.component';
import { PersonDataService } from '../catalog/person/person-add-edit/person.service';
import { OrderAddEditComponent } from '../commercial/order-add-edit/order-add-edit.component';
import { OrderDataService } from '../commercial/order-add-edit/order.service';
import { AdItem } from 'src/app/models/ad-item';
import { MediaMatcher } from '@angular/cdk/layout';
import { InvoiceDataService } from '../financial/invoice/invoice.service';
import { ReceivableDataService } from '../financial/receivable/receivable.service'
import { UserPermissionService } from '../user/user-permission/user-permission.service';
import { UserPermissionEditComponent } from '../user/user-permission/userPermission.component';
import { ChangeUserClientComponent } from '../user/change-userclient/change-userclient.component';

@Component({
  selector: 'app-groups',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss'],
  animations: [SharedAnimations]
})
export class ViewComponent extends PageSharedFns implements AfterViewInit, OnDestroy {

  form: AdItem<GenericDataService>;
  formAddEdit: any;
  id:any;
  
  private onUnitySub;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  constructor(
    public sharedInfo: SharedInfo,
    public userService: UserService,
    public http: HttpClient,
    public dialog: MatDialog,
    public route: ActivatedRoute,
    public deviceService: DeviceDetectorService,
    public changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private renderer: Renderer2) {
    super(dialog, route, deviceService);

    this.mobileQuery = media.matchMedia('(max-width: 600px)');

    this._mobileQueryListener = () => {
      changeDetectorRef.detectChanges();
    }


    this.route.params.subscribe(params => {
      this.tableName = params['tableName'];
      this.id = params['id'];
      this.data = [];
      this.initialize();
    });
    
    this.onUnitySub = this.userService.onUnityChange.subscribe(unity=>{
      this.fetch(null);     
      setTimeout(() => {
        this.data.forEach(element => {
          element.animateChangeUnity = true;
        });
        console.log('unitChanged');
      }, 1000);
    });
  }

  ngOnDestroy() {
    this.onUnitySub.unsubscribe();
  }

  //this.onKeyUpEvent.emit(event);

  @HostListener('window:keyup', ['$event'])
  onKeyUp(event: KeyboardEvent) {
    // console.log('Key:', event.key);
    // console.log('this.onKeyUpEvent:', this.onKeyUpEvent);
    this.onKeyUpEvent.emit(event.key);

    if(this.formAddEdit != null && this.formAddEdit.onKeyUpEvent != null){
      // if(this.$body.hasClass('overlay-active')) {
      //   this.formAddEdit.onKeyUpEvent.emit(event);
      // }
    }
  }


  initialize(){

    this.form = null;
    this.formAddEdit = null;
    

    switch (this.tableName) {

      case 'userPermission':
        this.form = new AdItem<UserPermissionService>(UserPermissionEditComponent, new UserPermissionService(this.sharedInfo, this.userService, this.http));
        break;

      case 'person':
        this.form = new AdItem<PersonDataService>(PersonAddEditComponent, new PersonDataService(this.sharedInfo, this.userService, this.http));
        break;

      case 'product':
        this.form = new AdItem<ProductDataService>(ProductAddEditComponent, new ProductDataService(this.sharedInfo, this.userService, this.http));
        break;

      case 'productGroup':
        this.form = new AdItem(GroupAddEditComponent, new GroupDataService(this.sharedInfo, this.userService, this.http));
        break;

      case 'stockMovement':
        this.form = new AdItem(StockMovementAddEditComponent, new StockMovementDataService(this.sharedInfo, this.userService, this.http));
        break;

      case 'order':
        this.form = new AdItem(OrderAddEditComponent, new OrderDataService(this.sharedInfo, this.userService, this.http));
        break;

      case 'invoice':
        this.form = new AdItem(StockMovementAddEditComponent, new InvoiceDataService(this.sharedInfo, this.userService, this.http));
        break;
      
      case 'receivable':
        this.form = new AdItem(StockMovementAddEditComponent, new ReceivableDataService(this.sharedInfo, this.userService, this.http));
        break;
    
      default:
        break;
    }

    this.appService = this.form.service;
    this.columns = this.form.service.getColums();
    this.displayedColumns = [];
    this.displayedColumns = [...this.columns.map(x => x.columnDef), 'cmd'];

    this.form.onCreated.subscribe((comp) => {

      this.formAddEdit = comp;
      console.log('formAddEdit:', this.formAddEdit);

      comp.onSaved.subscribe((dataFromAPI) => {
        console.log('dataFromAPI:', dataFromAPI);
        if(dataFromAPI){
          if(this.tableName == 'order'){
            this.fetch(dataFromAPI);
            this.selectedItem = dataFromAPI.data.mainData;
          } else {
            this.fetch(dataFromAPI);
          }
        } else {
          this.fetch(dataFromAPI);
        }
       
        this.renderer.removeClass(document.body, 'overlay-active');
      });

      comp.onCancelClick.subscribe((dataFromAPI) => {
        this.renderer.removeClass(document.body, 'overlay-active');
      });

    });

    

    this.form.onCommandExecuted.subscribe((cmd: string) => {
      console.log('cmd:', cmd);

      switch (cmd) {

        case 'share':
          //this.clipboard.writeText(this.formAddEdit.data.id);
          break;

        case 'save':
          this.formAddEdit.submit();
          break;

        case 'delete':
          this.delete();
          break;

        default:
          break;
      }
    });

    if(this.id) {
      this.openEdit(this.id);
    }
  }

  setCommands(edit: boolean = false){
    this.form.commands = [];
    this.form.commands.push({ cmd: 'share', icon: 'share', label: '' });
    this.form.commands.push({ cmd: 'save', icon: 'save', label: '' });


    this.form.moreCommands = [];
    if(edit == true)
    {
      this.form.moreCommands.push({ cmd: 'delete', icon: 'delete', label: 'Excluir Registro' });
    }
  }

  changeErp(userId) {
    const modalRef = this.dialog.open(ChangeUserClientComponent, {
      data: {
        userId: userId
      }
    });

    //modalRef.componentInstance.documentList = documentList;
    modalRef.componentInstance.onSaved.subscribe((resp) => {
      this.fetch();
      modalRef.close();
    });

  }

  openEdit(id) {
    this.setCommands(true);
    this.selectedItem = this.data.find(i=>i.id == id);
    this.appService.getItemDetails(id).subscribe(ret => {
      this.form.data = ret.data;
      this.form.component.prototype.idForEdit = ret.data.id;
      this.form.component.prototype.tableName = this.tableName;
      this.sharedInfo.onSetComponent.emit(this.form);
      this.renderer.addClass(document.body, 'overlay-active');

      //this.openModal<>(this.form.component);

    }, errRersp => {

    });

  }


  addItem() {
    this.setCommands(false);
    this.form.data = null;
    this.form.component.prototype.idForEdit = null;
    this.form.component.prototype.tableName = this.tableName;
    this.sharedInfo.onSetComponent.emit(this.form);
    this.renderer.addClass(document.body, 'overlay-active');
  }

  delete() {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-danger',
        cancelButton: 'btn'
      },
      buttonsStyling: false
    })

    swalWithBootstrapButtons.fire({
      position: 'top',
      title: "Confirmar Exclusão",
      text: "Confirma a exclusão do registro ?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sim, Excluir',
      cancelButtonText: 'Não',
      reverseButtons: true
    }).then((result) => {

      if (result.value) {
        this.appService.delete(this.selectedItem.id).subscribe(ret => {
          if (ret.success == true) {
            this.selectedItem = this.data.find(i=>i.id == this.selectedItem.id);

            console.log(this.selectedItem);
            console.log('index', this.data.indexOf(this.selectedItem));

            this.data.splice(this.data.indexOf(this.selectedItem), 1);
            this.data = [... this.data];

            this.renderer.removeClass(document.body, 'overlay-active');
          }
        });
      }

    })
  }
}
